import { render, staticRenderFns } from "./TransactionGrid.vue?vue&type=template&id=4a8e5237&scoped=true&"
import script from "./TransactionGrid.vue?vue&type=script&lang=js&"
export * from "./TransactionGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8e5237",
  null
  
)

export default component.exports